import {_utils} from "../../utils/_utils.js";
import {initCardsSlider} from "../../utils/cards-slider.js";

/**
 * Testimonials slider (TZ section 8): → moves one card forward, ← one back (see utils/cards-slider.js).
 */
export const testimonials = () => {
    return new Promise((resolve) => {
        _utils.initSection('.testimonials', (section) => init(section));
        resolve();
    });
};

const init = (section) => {
    const slider = section.querySelector('.testimonials__slider');
    if (!slider) return;

    initCardsSlider(
        slider,
        section.querySelector('.testimonials__nav-btn--prev'),
        section.querySelector('.testimonials__nav-btn--next')
    );
};
